export {default} from './ScreenSection';
